module.exports = __webpack_public_path__ + "img/4price.af76d5c1.png";